import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: 'black',
    },
    navigation: {
      boxShadow: theme.shadows[1],
      height: 'calc(100vh - 80px)',
      position: 'sticky',
      top: 80,
      overflow: 'auto',
      backgroundColor: theme.palette.primary.dark,
    },
    breadcrumbs: {
      margin: '16px !important',
    },
    item: {
      color: 'white',
      fontWeight: 700,
    },
    itemText: {
      lineHeight: 'normal !important',
      padding: '10px 0',
    },
    itemActive: {
      backgroundColor: `${theme.palette.primary.main} !important`,
    },
  })
);

export type PortfolioClasses = ReturnType<typeof useStyles>;
